import React, { lazy, Suspense } from "react";
const LazyAllRentContract = lazy(() => import("./AllRentContract"));
const LazyAllSellContract = lazy(() => import("./AllSellContract"));
const LazyPrintAllRentContract = lazy(() => import("./PrintAllRentContract"));
const LazyPrintAllSellContract = lazy(() => import("./PrintAllSellContract"));
const LazyView_AllRent = lazy(() => import("./ViewContracts/View_AllRent"));
const LazyView_AllSell = lazy(() => import("./ViewContracts/View_AllSell"));
const LazyAllSellContract_Failed = lazy(() =>
  import("./AllSellContract_Failed")
);
const LazyAllRentContract_Failed = lazy(() =>
  import("./AllRentContract_Failed")
);
export const AllRentContract = () => (
  <Suspense fallback="loading...">
    <LazyAllRentContract />
  </Suspense>
);
export const AllSellContract = () => (
  <Suspense fallback="loading...">
    <LazyAllSellContract />
  </Suspense>
);
export const PrintAllRentContract = () => (
  <Suspense fallback="loading...">
    <LazyPrintAllRentContract />
  </Suspense>
);
export const PrintAllSellContract = () => (
  <Suspense fallback="loading...">
    <LazyPrintAllSellContract />
  </Suspense>
);
export const View_AllRent = () => (
  <Suspense fallback="loading...">
    <LazyView_AllRent />
  </Suspense>
);
export const View_AllSell = () => (
  <Suspense fallback="loading...">
    <LazyView_AllSell />
  </Suspense>
);
export const AllSellContract_Failed = () => (
  <Suspense fallback="loading...">
    <LazyAllSellContract_Failed />
  </Suspense>
);
export const AllRentContract_Failed = () => (
  <Suspense fallback="loading...">
    <LazyAllRentContract_Failed />
  </Suspense>
);
